import { alpha, Avatar, Chip, Stack, Theme, Typography } from '@mui/material';

export const pairLabel = (displaySymbol: string) => `${displaySymbol}-USDC`;

// 细灰滚动条
export const thinScrollbarSx = (theme: Theme) => ({
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${alpha(theme.palette.text.primary, 0.24)} transparent`,
  '&::-webkit-scrollbar': { width: 6, height: 6 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 3,
    backgroundColor: alpha(theme.palette.text.primary, 0.24),
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.4),
  },
});

export const avatarColor = (seed: string) => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 360;
  }
  return `hsl(${hash}, 55%, 45%)`;
};

export function SymbolAvatar({ symbol, label, size = 32 }: { symbol: string; label: string; size?: number }) {
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.34,
        fontWeight: 700,
        bgcolor: avatarColor(symbol),
        color: '#fff',
      }}
    >
      {label.slice(0, 2).toUpperCase()}
    </Avatar>
  );
}

// 币对名 + HIP-3 dex 徽标
export function PairName({ displaySymbol, dex }: { displaySymbol: string; dex: string }) {
  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0 }}>
      <Typography variant="subtitle2" noWrap>
        {pairLabel(displaySymbol)}
      </Typography>
      {dex ? <Chip label={dex} size="small" variant="outlined" sx={{ height: 18, fontSize: 11 }} /> : null}
    </Stack>
  );
}

export function ChangePercent({ value }: { value: number }) {
  return (
    <Typography variant="caption" sx={{ color: value >= 0 ? 'success.main' : 'error.main', fontWeight: 600 }}>
      {`${value >= 0 ? '+' : ''}${value.toFixed(2)}%`}
    </Typography>
  );
}
